import { useLayoutContext } from '../../context/layoutContext'
import type { SubTemplateFieldValue } from '../../types/templateModel'
import { SubTemplatedFieldValueDefaultSelected } from './SubTemplatedFieldValueDefaultSelected'
import { SubTemplatedFieldValueNameCell } from './SubTemplatedFieldValueNameCell'
import { SubTemplatedFieldValueType } from './SubTemplatedFieldValueType'

type Props = {
  variant: SubTemplateFieldValue
  column: number
}

export const SubTemplatedFieldValueCell = ({ variant, column }: Props) => {
  const {
    preferences: {
      templates: { isShowingSimplifiedView },
    },
  } = useLayoutContext()

  switch (column) {
    case 0:
      return <SubTemplatedFieldValueNameCell variant={variant} />
    case 1:
      return isShowingSimplifiedView ? (
        <SubTemplatedFieldValueDefaultSelected variant={variant} />
      ) : (
        <SubTemplatedFieldValueType variant={variant} />
      )
    case 2:
      return null
    case 3:
      return <SubTemplatedFieldValueDefaultSelected variant={variant} />
    case 4:
      return null
    default:
      throw new Error(`Nonexistent column ${column}`)
  }
}
